import { useQuery } from 'react-query';

import { Person } from '../../../../backend/src/case/person/person.entity';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetSubsetPersons = (matterId: string | null, subsetId: string | null) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Person[]>(
    [QueryEntity.SubsetPersons, { matterId, subsetId }],
    async () => {
      return fetch(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/persons`, fetchConfigGET).then(
        (res) => {
          if (!res.ok) {
            throw new Error('Network response was not ok');
          }
          return res.json();
        },
      );
    },
    {
      enabled: !!matterId && !!subsetId,
      refetchOnWindowFocus: false,
    },
  );
};
